import React from "react";
import ConfigurationPage from "templates/ConfigurationPage";
import ResidentContent from "./ResidentContent"

const NewResident = (props) => {
    const {history} = props;
    
    return (
        <ConfigurationPage
            history={history}
            pageTitle="Residents"
            pageSubTitle="Add new resident"
        >
            <ConfigurationPage.Content>
                <ResidentContent {...props}/>
            </ConfigurationPage.Content>
        </ConfigurationPage>
    );
};

export default NewResident;